module.exports = [{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby@5.15.0_@types+webpack@5.28.5_react-dom@18.2.0_react@18.2.0__react@18.2.0_type-fe_06bbf4a7321812afbaec6299aea4aace/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
